var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSignatureNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "{props.fill}",
    d: "M2.77656 10.75C2.80781 10.75 2.83906 10.7469 2.87031 10.7422L5.49844 10.2812C5.52969 10.275 5.55938 10.2609 5.58125 10.2375L12.2047 3.61406C12.2192 3.59961 12.2307 3.58244 12.2385 3.56354C12.2463 3.54463 12.2504 3.52437 12.2504 3.50391C12.2504 3.48344 12.2463 3.46318 12.2385 3.44428C12.2307 3.42538 12.2192 3.40821 12.2047 3.39375L9.60781 0.795313C9.57812 0.765625 9.53906 0.75 9.49687 0.75C9.45469 0.75 9.41563 0.765625 9.38594 0.795313L2.7625 7.41875C2.73906 7.44219 2.725 7.47031 2.71875 7.50156L2.25781 10.1297C2.24261 10.2134 2.24804 10.2995 2.27364 10.3807C2.29923 10.4618 2.34421 10.5355 2.40469 10.5953C2.50781 10.6953 2.6375 10.75 2.77656 10.75ZM3.82969 8.025L9.49687 2.35938L10.6422 3.50469L4.975 9.17031L3.58594 9.41562L3.82969 8.025ZM12.5 12.0625H1C0.723437 12.0625 0.5 12.2859 0.5 12.5625V13.125C0.5 13.1938 0.55625 13.25 0.625 13.25H12.875C12.9438 13.25 13 13.1938 13 13.125V12.5625C13 12.2859 12.7766 12.0625 12.5 12.0625Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignatureNew);
export default __webpack_public_path__ + "static/media/signature-new.af5e8453.svg";
export { ForwardRef as ReactComponent };